export const PRODUCTS = [
  {
    slug: "filter-coffee-powder",
    name: "TMV Filter Coffee Powder",
    short:
      "Our signature slow-roasted blend, ground to the perfect size for the traditional South Indian filter.",
    description:
      "The coffee our brand was built on. Handpicked beans are roasted slowly in small batches and ground for the traditional filter, so every decoction fills the home with the aroma only real filter coffee can. Strong, honest and made for the davara-tumbler ritual.",
    highlights: [
      "Slow-roasted in small batches",
      "Ground for the traditional filter",
      "Strong decoction, full aroma",
    ],
    aroma: "Deep and nutty, with a quiet hint of caramel",
    taste: "Bold and full-bodied, with a lingering chocolate finish",
    suitable: "Traditional filter brewing, morning cups, households & cafés",
    packs: ["250 g", "500 g", "1 kg"],
    image:
      "https://static.prod-images.emergentagent.com/jobs/2e8907c4-4100-4573-95dc-8f4deef5c7ce/images/a769fef5e163b287938891a9548830d520958a6c2e68fd629ea2612b3811fa07.jpeg",
  },
  {
    slug: "premium-tea",
    name: "TMV Premium Tea",
    short:
      "A carefully selected leaf tea that brews into a warm, comforting, full-flavoured cup.",
    description:
      "For the tea moments of the day — the first cup at dawn, the shared one at four. TMV Premium Tea is selected for a clean, strong liquor that pairs beautifully with milk, and stays smooth even when brewed bold.",
    highlights: [
      "Selected quality leaf tea",
      "Full-flavoured, smooth liquor",
      "Perfect with milk, never bitter",
    ],
    aroma: "Fresh leafy notes with a gentle sweetness",
    taste: "Warm, rounded and full-flavoured",
    suitable: "Daily family brewing, offices & tea stalls",
    packs: ["250 g", "500 g"],
    image:
      "https://static.prod-images.emergentagent.com/jobs/2e8907c4-4100-4573-95dc-8f4deef5c7ce/images/f4a9d2d3b6695ef1a97aae9ae16c724009ce6c9a5c2e7f02dea338a8a1675ea4.jpeg",
  },
  {
    slug: "assam-tea-powder",
    name: "TMV Assam Tea Powder",
    short:
      "Strong Assam leaves that give a deep colour and a brisk, malty strength to every cup.",
    description:
      "Grown in the rich alluvial soil of Assam, this tea powder is chosen for its strength and deep golden liquor. One spoon is enough to wake the whole pot — the kind of tea that turns a short break into a proper conversation.",
    highlights: [
      "Strong, malty Assam character",
      "Deep colour and brisk liquor",
      "A little goes a long way",
    ],
    aroma: "Rich malt with earthy depth",
    taste: "Brisk and strong, with a satisfying body",
    suitable: "Strong milk tea, hotels, canteens & bulk brewing",
    packs: ["250 g", "500 g", "1 kg"],
    image:
      "https://static.prod-images.emergentagent.com/jobs/2e8907c4-4100-4573-95dc-8f4deef5c7ce/images/f29177bccdd11828b6171a4cdf32d5e515b852936bb5c25334d7479276f58509.jpeg",
  },
  {
    slug: "instant-coffee",
    name: "TMV Instant Coffee",
    short:
      "Real coffee convenience — a quick cup with the honest, familiar taste of TMV.",
    description:
      "For the busy mornings and late-night study tables. TMV Instant Coffee dissolves in seconds yet carries the same honest coffee character we roast into everything — a comforting cup, anywhere, anytime.",
    highlights: [
      "Ready in seconds, no brewing needed",
      "Honest roasted coffee character",
      "Great hot or cold",
    ],
    aroma: "Warm roasted notes",
    taste: "Smooth, familiar and satisfyingly strong",
    suitable: "Quick cups at home, travel, offices & students",
    packs: ["50 g", "100 g", "200 g"],
    image:
      "https://static.prod-images.emergentagent.com/jobs/2e8907c4-4100-4573-95dc-8f4deef5c7ce/images/4e1c9aa74a6b3859c4f5042ed99b5ba5069ebba81d191e0021a747a396711f45.jpeg",
  },
];

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);
